/*List of Enums*/
import Translate from "@/assets/media/svg/globe.svg"
import Grammer from "@/assets/media/svg/grammar.svg"
import Improve from "@/assets/media/svg/improve.svg"
import Longer from "@/assets/media/svg/long.svg"
import Shorter from "@/assets/media/svg/short.svg"
import Tone from "@/assets/media/svg/tone.svg"
import i18n from "@/plugins/i18n"

const CHANGE_USER_STATUS = {
    ACTIVATED: { name: i18n.global.t("constants_text.activated") },
    DEACTIVATED: { name: i18n.global.t("constants_text.deactivated") },
}
const USER_STATUS = {
    INVITED: { name: "Invited" },
    ACTIVATED: { name: "Activated" },
    DEACTIVATED: { name: "Deactivated" },
}
const CUSTOM_EMAILS = {
    INVITATION: {
        name: i18n.global.t("notification_tab.drop_dawn_text.invitation"),
    },
    REJECTION: {
        name: i18n.global.t("notification_tab.drop_dawn_text.rejection"),
    },
    RESULT: {
        name: i18n.global.t("notification_tab.drop_dawn_text.result"),
    },
    COMPLETION: {
        name: i18n.global.t("notification_tab.drop_dawn_text.completion"),
    },
    REMINDER: {
        name: i18n.global.t("notification_tab.drop_dawn_text.reminder"),
    },
}
const QUESTION_LAYOUT = [
    {
        id: 1,
        value: "HORIZONTAL",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 25" fill="none">
<rect x="3.85" y="4.51675" width="16.3" height="16.3" rx="1.15" stroke="#6D6D80" stroke-width="1.7"/>
<path d="M12 17.6667V7.66675C12 7.11446 12.4477 6.66675 13 6.66675H17C17.5523 6.66675 18 7.11446 18 7.66675V17.6667C18 18.219 17.5523 18.6667 17 18.6667H13C12.4477 18.6667 12 18.219 12 17.6667Z" fill="#6D6D80"/>
</svg>`,
        labelKey: "custom_que.horizontal_layout",
    },
    {
        id: 2,
        value: "VERTICAL",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 25" fill="none">
<rect x="20.15" y="4.51675" width="16.3" height="16.3" rx="1.15" transform="rotate(90 20.15 4.51675)" stroke="#6D6D80" stroke-width="1.7"/>
<path d="M7 12.6667L17 12.6667C17.5523 12.6667 18 13.1145 18 13.6667V17.6667C18 18.219 17.5523 18.6667 17 18.6667H7C6.44771 18.6667 6 18.219 6 17.6667L6 13.6667C6 13.1145 6.44771 12.6667 7 12.6667Z" fill="#6D6D80"/>
</svg>`,
        labelKey: "custom_que.vertical_layout",
    },
]

const OPTION_LAYOUT = [
    {
        id: 1,
        value: "LINEAR",
        icon: `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.25 1.35645L16.25 1.35645C16.8023 1.35645 17.25 1.80416 17.25 2.35645V4.35645C17.25 4.90873 16.8023 5.35645 16.25 5.35645L2.25 5.35645C1.69771 5.35645 1.25 4.90873 1.25 4.35645V2.35645C1.25 1.80416 1.69771 1.35645 2.25 1.35645Z" fill="#3F4254"/>
        <path d="M2.25 7.35645L16.25 7.35645C16.8023 7.35645 17.25 7.80416 17.25 8.35645V10.3564C17.25 10.9087 16.8023 11.3564 16.25 11.3564L2.25 11.3564C1.69771 11.3564 1.25 10.9087 1.25 10.3564V8.35645C1.25 7.80416 1.69771 7.35645 2.25 7.35645Z" fill="#3F4254"/>
        <path d="M2.25 13.3564L16.25 13.3564C16.8023 13.3564 17.25 13.8042 17.25 14.3564V16.3564C17.25 16.9087 16.8023 17.3564 16.25 17.3564L2.25 17.3564C1.69771 17.3564 1.25 16.9087 1.25 16.3564V14.3564C1.25 13.8042 1.69771 13.3564 2.25 13.3564Z" fill="#3F4254"/>
        </svg>`,
        labelKey: "custom_que.linear_layout",
    },
    {
        id: 2,
        value: "GRID",
        icon: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 8L2 8C1.44772 8 1 7.55228 1 7L1 2C1 1.44772 1.44772 1 2 1L4 1C4.55228 1 5 1.44772 5 2L5 7C5 7.55228 4.55228 8 4 8Z" fill="#3F4254"/>
        <path d="M10 8L8 8C7.44772 8 7 7.55228 7 7L7 2C7 1.44772 7.44772 1 8 1L10 1C10.5523 1 11 1.44772 11 2L11 7C11 7.55228 10.5523 8 10 8Z" fill="#3F4254"/>
        <path d="M16 8L14 8C13.4477 8 13 7.55228 13 7L13 2C13 1.44772 13.4477 1 14 1L16 1C16.5523 1 17 1.44772 17 2L17 7C17 7.55228 16.5523 8 16 8Z" fill="#3F4254"/>
        <path d="M4 17H2C1.44772 17 1 16.5523 1 16L1 11C1 10.4477 1.44772 10 2 10L4 10C4.55228 10 5 10.4477 5 11L5 16C5 16.5523 4.55228 17 4 17Z" fill="#3F4254"/>
        <path d="M10 17H8C7.44772 17 7 16.5523 7 16L7 11C7 10.4477 7.44772 10 8 10L10 10C10.5523 10 11 10.4477 11 11L11 16C11 16.5523 10.5523 17 10 17Z" fill="#3F4254"/>
        <path d="M16 17H14C13.4477 17 13 16.5523 13 16L13 11C13 10.4477 13.4477 10 14 10L16 10C16.5523 10 17 10.4477 17 11L17 16C17 16.5523 16.5523 17 16 17Z" fill="#3F4254"/>
        </svg> `,
        labelKey: "custom_que.grid_layout",
    },
]

const USER_ROLE = {
    OWNER: { name: "Owner" },
    ADMIN: { name: "Admin" },
    MEMBER: { name: "Member" },
}

const EN_CURRENCY = {
    INR: "en-IN",
    USD: "en-US",
    GBP: "en-GB",
}
const STATUS_COLORS = {
    INVITED: "blck-txt-clr",
    COMPLETED: "grn-clr-txt",
    IN_PROGRESS: "lght-ylw-clr-txt",
    ENROLLED: "lght-ylw-clr-txt",
    DISQUALIFIED: "red-clr-txt",
    REJECTED: "red-clr-txt",
    INVITATION_EXPIRED: "red-clr-txt",
    REMINDER_SENT_MANUALLY: "blck-txt-clr",
    REMINDER_SENT_BY_SYSTEM: "blck-txt-clr",
    TEST_RESULT_SENT_MANUALLY: "blck-txt-clr",
    TEST_RESULT_SENT_BY_SYSTEM: "blck-txt-clr",
    TERMINATED: "red-clr-txt",
}

const CANDIDATE_STAGES = {
    NOT_YET_EVALUATED: { name: "NOT YET EVALUATED" },
    EVALUATED: { name: "EVALUATED" },
    INVITED_FOR_ASSESSMENT: { name: "INVITED FOR ASSESSMENT" },
    ENROLLED_FOR_ASSESSMENT: { name: "ENROLLED FOR ASSESSMENT" },
    ASSESSMENT_COMPLETED: { name: "ASSESSMENT COMPLETED" },
    SHORTLISTED: { name: "SHORTLISTED" },
    INVITED_FOR_INTERVIEW: { name: "INVITED FOR INTERVIEW" },
    REFERENCE_VERIFIED: { name: "REFERENCE VERIFIED" },
    OFFER_SENT: { name: "OFFER SENT" },
    OFFER_DECLINED: { name: "OFFER DECLINED" },
    CANDIDATE_WITHDREW: { name: "CANDIDATE WITHDREW" },
    CANDIDATE_UNRESPONSIVE: { name: "CANDIDATE UNRESPONSIVE" },
    REJECTED: { name: "REJECTED" },
    HIRED: { name: "HIRED" },
}

const CANDIDATE_STAGE_COLORS = {
    REJECTED: "red-clr-txt",
    HIRED: "grn-clr-txt",
    SHORTLISTED: "blu-clr-txt",
    DEFAULT: "blck-txt-clr",
}

const PRODCODINGTESTID = "63480d3317693702adfa5178"
const STAGINGCODINGTESTID = "630f5153aa091fd0cd1cc83c"

const LTI_ORG_ID = "663b7bc129be1f46834c47b6"

const INTEGRATIONHOST = "https://integrations.testlify.com"
const INTEGRATIONHOSTSTAGING = "https://testlify-integration.herokuapp.com"
const ISUSA = "https://integrations-us.testlify.com"
const ISKSA = "https://integrations-ksa.testlify.com"

const NOLIMITDURATION = 259200
const CUSTOM_QUESTION_DURATION = [
    { id: 1, value: 10, name: "10 " + i18n.global.t("constants_text.seconds") },
    { id: 2, value: 30, name: "30 " + i18n.global.t("constants_text.seconds") },
    { id: 3, value: 60, name: "1 " + i18n.global.t("constants_text.minute") },
    { id: 4, value: 120, name: "2 " + i18n.global.t("constants_text.minutes") },
    { id: 5, value: 300, name: "5 " + i18n.global.t("constants_text.minutes") },
    {
        id: 6,
        value: 600,
        name: "10 " + i18n.global.t("constants_text.minutes"),
    },
    {
        id: 7,
        value: 1800,
        name: "30 " + i18n.global.t("constants_text.minutes"),
    },
    { id: 8, value: 1, name: i18n.global.t("constants_text.custom") },
    { id: 9, value: 3600, name: i18n.global.t("constants_text.no_limit") },
]

const EXHAUSTED_THE_LIMIT = i18n.global.t("constants_text.limit_exhaust")

const COMPANY_QUESTIONS_DURATION_LIST = [
    {
        id: 1,
        value: 10,
        name: "10 " + i18n.global.t("constants_text.seconds"),
    },
    {
        id: 2,
        value: 30,
        name: "30 " + i18n.global.t("constants_text.seconds"),
    },
    {
        id: 3,
        value: 60,
        name: "1 " + i18n.global.t("constants_text.minute"),
    },
    {
        id: 4,
        value: 120,
        name: "2 " + i18n.global.t("constants_text.minutes"),
    },
    {
        id: 5,
        value: 300,
        name: "5 " + i18n.global.t("constants_text.minutes"),
    },
    { id: 8, value: 1, name: i18n.global.t("constants_text.custom") },
    {
        id: 9,
        value: 259200,
        name: i18n.global.t("constants_text.no_limit"),
    },
]
export {
    CANDIDATE_STAGES,
    CANDIDATE_STAGE_COLORS,
    CHANGE_USER_STATUS,
    COMPANY_QUESTIONS_DURATION_LIST,
    CUSTOM_EMAILS,
    CUSTOM_QUESTION_DURATION,
    EN_CURRENCY,
    EXHAUSTED_THE_LIMIT,
    INTEGRATIONHOST,
    INTEGRATIONHOSTSTAGING,
    LTI_ORG_ID,
    NOLIMITDURATION,
    OPTION_LAYOUT,
    PRODCODINGTESTID,
    QUESTION_LAYOUT,
    STAGINGCODINGTESTID,
    STATUS_COLORS,
    USER_ROLE,
    USER_STATUS,
    ISUSA,
    ISKSA,
}
export const ADP_DEFUALT_VISIBLE_COLUMNS = [
    "name",
    "invitedAt",
    "avgScorePercentage",
    "phone",
    "grading",
    "reviewRating",
    "candidateStatus",
    "candidateStage",
    "candidateGrading",
    "action",
]
export const ALP_DEFUALT_VISIBLE_COLUMNS = ["createdOn", "createdBy"]
export const ADP_DEFAULT_SORT = {
    column: "invitedAt",
    order: "descending",
}

export const DEFAULT_ASSESSMENT_CONFIG = {
    mandatoryTestLibrary: false,
    mandatoryCamMic: false,
    capture30sec: false,
    customRedirectingPage: "",
    redirectMethod: "DEFAULT_REDIRECT_PAGE",
    assessmentStatus: "",
    skipRegistration: false,
    skipEmailVerificationForPublicLink: false,
    recipientList: [],
    testAdministratorList: "",
    isMultipleMonitorEnabled: false,
    enableGrammarly: false,
    disableFullScreen: false,
    logGenerationRequired: false,
    forceFullScreen: false,
    sendAssessmentResultEmail: false,
    invitationEmailLinkValidity: 0,
    AssessmentDeadlineType: "NEVER_EXPIRE",
    invitationEmailLinkExpiryDate: "",
    assessmentDeadlineTz: "",
    customFields: [],
    numberOfAttempts: 1,
    assessmentInstructions: "",
    notificationPresetId: "",
    enableNavigationToPreviousQuestions: true,
    enableCalculator: false,
    enableFeedbackAfterSection: false,
    enableSpellCheck: true,
    enableFeedback: false,
    enableFeedbackComment: true,
    screenShare: false,
    snapshotIntervalType: "DEFAULT_SNAPSHOT_INTERVAL",
    customSnapshotInterval: 120,
    dualCameraProctoring: false,
    candidateAccommodation: false,
    disableMobileAndTabletDevices: true,
    useMobileFallback: true,
    generateAiInsight: true,
    generateInterviewQuestions: false,
    enabledPracticeTest: false,
    violation: {
        tabSwitch: {
            warning: false,
            limit: 5,
            tolerance: 5,
        },
        fullScreenExit: {
            warning: false,
            limit: 5,
            tolerance: 5,
        },
        photoAnalysis: {
            warning: false,
            limit: 5,
            tolerance: 5,
        },
        copyPaste: {
            warning: false,
            limit: 5,
            showWarning: true,
        },
        mouseOut: {
            warning: false,
            limit: 0,
            tolerance: 5,
        },
        aiPlugin: {
            warning: false,
            limit: 5,
        },
    },
    isHonestyAgreement: false,
    customHonestyAgreement: "",
    verifyPrivateInvite: false,
    enableFaceDetection: false,
    verifyPassword: "",
    restrictionType: "",
    restrictedDomains: [],
    ipProctoringEnabled: false,
    sessionRecording: false,
    demographicFeedbackForm: false,
    autoPlayWelcomeVideo: false,
    access: [],
    weightConfig: {
        testLib: {},
        customQuestion: {},
    },
    scoreType: "DEFAULT",
    enableAccessibility: false,
    enableInstructions: true,
    enableAssessmentSummary: true,
    enableSectionSummary: true,
    coolDownSetting: {
        cooldownUnit: "none",
        cooldownValue: null,
    },
    rejectionThreshold: 74.99,
    sendRejectionEmail: false,
    certification: {
        certificateTemplateId: "",
        scoreThreshold: 80,
        title: "",
    },
}

export const PSYCHOMETRIC_TEST_LIBRARY_TYPE_ID = "631730df1a23bc7a075f8269"

export const INTERVU_WORKSPACE_ID = "66b6177efefa40384c1fa072"

export const SMART_TEST_LIBRARY_SUBTYPE = "64467b2c6fe15ecd7a67446a"

export const DISC_TEST_LIBRARY_SUBTYPE = "64cd10bf98d335f6c859838c"

export const SUPPORT_EMAIL = "support@testlify.com"
export const DEFAULT_SHORTLIST_TEMPLATE =
    "\n\nWe are pleased to inform you that you have been shortlisted for the next phase of our selection process. Thank you for your interest in WORKSPACE_NAME and for the time and effort you've put into your application.\n\nWe will be in touch shortly with further instructions on the upcoming steps. We look forward to getting to know you better and exploring the possibility of you joining our team.\n \nBest regards\n"
export const SAWAEED_EMPLOYER_DOMAIN = "https://app.tamayaz.sa"
export const SAWAEED_STAGING_DOMAIN = "https://stg.tamayaz.sa"
export const PERSONAL_EMAIL_DOMAINS = ["gmail.com", "yahoo.com", "hotmail.com"]
export const QUESTION_GUIDELINES_LINK =
    "https://help.testlify.com/article/306-guidelines-for-creating-custom-questions"

export const VIDEO_DELETED_AFTER_90_DAYS_LINK =
    "https://help.testlify.com/article/251-retention-policy-for-audio-and-video-recordings-in-assessments"
export const QUESTION_LIST_TYPE = [
    {
        id: 1,
        value: "SINGLE_SELECT",
        name: i18n.global.t("constants_text.single_select"),
    },
    {
        id: 2,
        value: "WRITTEN_ANSWER",
        name: i18n.global.t("constants_text.long_answer"),
    },
    {
        id: 3,
        value: "VIDEO_ANSWER",
        name: i18n.global.t("constants_text.video"),
    },
]

export const TIME_DROPDOWN = [
    {
        id: 0,
        value: "Custom",
        name: i18n.global.t("constants_text.custom"),
    },
    {
        id: 1,
        value: "No limit",
        name: i18n.global.t("constants_text.no_limit"),
    },
]

export const QUESTION_TYPES = [
    {
        id: 0,
        value: "ALL",
        name: i18n.global.t("constants_text.all"),
    },
    {
        id: 1,
        value: "CUSTOM",
        name: i18n.global.t("constants_text.custom"),
    },
]

export const DIFFICULTY_LEVEL_LIST = [
    {
        id: 1,
        value: "BEGINNER",
        name: i18n.global.t("constants_text.beginner"),
    },
    {
        id: 2,
        value: "INTERMEDIATE",
        name: i18n.global.t("constants_text.intermediate"),
    },
    {
        id: 3,
        value: "ADVANCED",
        name: i18n.global.t("constants_text.advanced"),
    },
    {
        id: 4,
        value: "NOT_APPLICABLE",
        name: i18n.global.t("generic_test.not_applicable"),
    },
]

export const TIMER_TEST_TYPE = [
    // {
    //     id: 1,
    //     value: "Question Level",
    //     name: i18n.global.t("configuration_tab.que_level"),
    // },
    {
        id: 2,
        value: "Test Level",
        name: i18n.global.t("configuration_tab.test_level"),
    },
]

export const PRIVACY_POLICY_URL = "https://testlify.com/privacy-policy/"
export const TERMS_CONDITION_URL = "https://testlify.com/terms/"

export const S3DOMAINS = [
    "cdn.",
    "cdn-global.",
    "testlify-eu",
    "testlify-eu-staging",
]

export const ALBAYANASSESSMENT_DOMAIN = "https://app.albayanassessment.com"

export const ONEDRIVE_SIGNOUT_URL = "https://onedrive.live.com"

export const durationOptions = [
    {
        id: 1,
        value: 10,
        name: "10 " + i18n.global.t("constants_text.seconds"),
    },
    {
        id: 2,
        value: 30,
        name: "30 " + i18n.global.t("constants_text.seconds"),
    },
    {
        id: 3,
        value: 60,
        name: "1 " + i18n.global.t("constants_text.minute"),
    },
    {
        id: 4,
        value: 120,
        name: "2 " + i18n.global.t("constants_text.minutes"),
    },
    {
        id: 5,
        value: 300,
        name: "5 " + i18n.global.t("constants_text.minutes"),
    },
    { id: 8, value: 1, name: i18n.global.t("constants_text.custom") },
    {
        id: 9,
        value: 0,
        name: i18n.global.t("constants_text.no_limit"),
    },
]
export const SAUDI_ARABIA = "Saudi Arabia"
export const EUROPE = "Europe"
export const USA = "United States"

export const DOCUMENT_SCORING_LEVEL = [
    {
        id: 1,
        value: "QUESTION",
        name: i18n.global.t("single_option_modal.question_level"),
    },
    {
        id: 2,
        value: "CRITERIA",
        name: i18n.global.t("single_option_modal.criteria_level"),
    },
    {
        id: 3,
        value: "TEST_CASE",
        name: i18n.global.t("coding_test_que_modal.test_case_level"),
    },
]

export const AI_TYPE_LIST = [
    {
        aiType: "grammar",
        aiName: i18n.global.t("ai_type_list.fix_spelling_grammar"),
        imgUrl: Grammer,
    },
    {
        aiType: "improve",
        aiName: i18n.global.t("ai_type_list.improve_writing"),
        imgUrl: Improve,
    },
    {
        aiType: "shorter",
        aiName: i18n.global.t("ai_type_list.make_shorter"),
        imgUrl: Shorter,
    },
    {
        aiType: "longer",
        aiName: i18n.global.t("ai_type_list.make_longer"),
        imgUrl: Longer,
    },
    {
        aiType: "tone",
        aiName: i18n.global.t("ai_type_list.change_tone"),
        imgUrl: Tone,
    },
    {
        aiType: "translate",
        aiName: i18n.global.t("ai_type_list.translate"),
        imgUrl: Translate,
    },
]

export const AI_TONE_LIST = [
    {
        toneType: "professional",
        shortName: i18n.global.t("tone_list_type.professional"),
        name: i18n.global.t("tone_list_value.change_tone_to_professional"),
    },
    {
        toneType: "empathetic",
        shortName: i18n.global.t("tone_list_type.empathetic"),
        name: i18n.global.t("tone_list_value.change_tone_to_empathetic"),
    },
    {
        toneType: "casual",
        shortName: i18n.global.t("tone_list_type.casual"),
        name: i18n.global.t("tone_list_value.change_tone_to_casual"),
    },
    {
        toneType: "neutral",
        shortName: i18n.global.t("tone_list_type.neutral"),
        name: i18n.global.t("tone_list_value.change_tone_to_neutral"),
    },
    {
        toneType: "educational",
        shortName: i18n.global.t("tone_list_type.educational"),
        name: i18n.global.t("tone_list_value.change_tone_to_educational"),
    },
]

export const AI_LANGUAGE_TRANSLATE_LIST = [
    {
        translateType: "english",
        shortName: i18n.global.t("translate_list_type.english"),
        name: i18n.global.t("translate_list_value.translate_to_english"),
    },
    {
        translateType: "arabic",
        shortName: i18n.global.t("translate_list_type.arabic"),
        name: i18n.global.t("translate_list_value.translate_to_arabic"),
    },
    {
        translateType: "dutch",
        shortName: i18n.global.t("translate_list_type.dutch"),
        name: i18n.global.t("translate_list_value.translate_to_dutch"),
    },
    {
        translateType: "french",
        shortName: i18n.global.t("translate_list_type.french"),
        name: i18n.global.t("translate_list_value.translate_to_french"),
    },
    {
        translateType: "german",
        shortName: i18n.global.t("translate_list_type.german"),
        name: i18n.global.t("translate_list_value.translate_to_german"),
    },
]

export const EditAccessOptions = {
    ALL_USERS: "ALL_USERS",
    ONLY_ME: "ONLY_ME",
    ROLES: "ROLES",
    USERS: "USERS",
}

export const CODING_AI_COMPETENCY_SKILLS = [
    "Code readability",
    "Optimality of solution",
    "Edge case handling",
    "Modularity & reusability",
    "Error handling",
]
export const SMS_TEMPLATE_BODY =
    "Hi {CANDIDATE_FIRST_NAME}, you’re invited to take the {ASSESSMENT_NAME} for {WORKSPACE_NAME}.\n" +
    "Start: {ASSESSMENT_URL}\n" +
    "Deadline: {EXPIRY_DATE_TIME}"

export const AUDIO_AI_COMPETENCY_SKILLS = [
    "Grammar",
    "Vocabulary",
    "Comprehension",
]

export const DEFAULT_AI_COMPETENCY_SKILLS = [
    "Grammar",
    "Vocabulary",
    "Fluency",
    "Comprehension",
]

export const FULL_SCREEN_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L9.33333 9.3" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 17.9641L9.33333 14.6641" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.0002 17.9641L14.7002 14.6641" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.9665 6L14.6665 9.3" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 6H18V9" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18 15V18H15" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 18H6V15" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 9V6H9" stroke="#3F4254" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`

export const CLOSE_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.31952 8.31952C8.74555 7.89349 9.43627 7.89349 9.8623 8.31952L12 10.4572L14.1377 8.31952C14.5637 7.89349 15.2545 7.89349 15.6805 8.31952C16.1065 8.74555 16.1065 9.43627 15.6805 9.8623L13.5428 12L15.6805 14.1377C16.1065 14.5637 16.1065 15.2545 15.6805 15.6805C15.2545 16.1065 14.5637 16.1065 14.1377 15.6805L12 13.5428L9.8623 15.6805C9.43627 16.1065 8.74555 16.1065 8.31952 15.6805C7.89349 15.2545 7.89349 14.5637 8.31952 14.1377L10.4572 12L8.31952 9.8623C7.89349 9.43627 7.89349 8.74555 8.31952 8.31952Z" fill="#3F4254"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.18182C6.57757 2.18182 2.18182 6.57757 2.18182 12C2.18182 17.4224 6.57757 21.8182 12 21.8182C17.4224 21.8182 21.8182 17.4224 21.8182 12C21.8182 6.57757 17.4224 2.18182 12 2.18182ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#3F4254"/>
</svg>`

export const TALENT_TYPE_PROFILE_LIBRARY_ID = "686263248f9b6ed141923940"

export const SINGLE_SELECT_OPTIONS = [
    {
        format: "PLAIN",
        description: "",
        isCorrect: true,
        _id: 0,
        score: 1,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 1,
        score: 0,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 2,
        score: 0,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 3,
        score: 0,
    },
]

export const RANKING_OPTIONS = [
    { format: "PLAIN", description: "", isCorrect: true, _id: 0 },
    { format: "PLAIN", description: "", isCorrect: true, _id: 1 },
    { format: "PLAIN", description: "", isCorrect: true, _id: 2 },
]

export const DROPDOWN_OPTIONS = [
    {
        format: "PLAIN",
        description: "",
        isCorrect: true,
        _id: 0,
        score: 1,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 1,
        score: 0,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 2,
        score: 0,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 3,
        score: 0,
    },
]

export const YES_NO_OPTIONS = [
    {
        format: "PLAIN",
        description: i18n.global.t("choice_question.yes"),
        isCorrect: true,
        _id: 0,
        score: 1,
    },
    {
        format: "PLAIN",
        description: i18n.global.t("choice_question.no"),
        isCorrect: false,
        _id: 1,
        score: 0,
    },
]

export const MULTI_SELECT_OPTIONS = [
    {
        format: "PLAIN",
        description: "",
        isCorrect: true,
        _id: 0,
        score: 1,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: true,
        _id: 1,
        score: 1,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 2,
        score: 0,
    },
    {
        format: "PLAIN",
        description: "",
        isCorrect: false,
        _id: 3,
        score: 0,
    },
]
export const AHM_DOMAIN = "https://assess.ahmvirtualscreen.com"
export const EXCLUDED_USER_MAILS_FOR_AHM = [
    "americanhealthmarketplace.com",
    "americanhm.org",
    "hnrtech.com",
    "testlify.com",
]
